import { render, staticRenderFns } from "./invoice-editor.vue?vue&type=template&id=4a20d4cc&scoped=true&"
import script from "./invoice-editor.vue?vue&type=script&lang=js&"
export * from "./invoice-editor.vue?vue&type=script&lang=js&"
import style0 from "./invoice-editor.vue?vue&type=style&index=0&id=4a20d4cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20d4cc",
  null
  
)

export default component.exports